import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Link } from '@mui/material';

function Linked({ style, to, target = '_self', children }) {
	return (
		<Link
			component={ReactRouterLink}
			to={to}
			target={target}
			underline="none"
			sx={style || { width: '100%' }}
		>
			{children}
		</Link>
	);
}
export default Linked;
